import React from 'react'
import styled from 'styled-components'
import InputText from '../../../components/Input/InputText'
import Button from '../../../components/Button/Button'
import CloseCircleIcon from '../../../components/Icons/CloseCircleIcon'
import { theme } from '../../../theme'

const PeopleSearchBar = ({ value, placeholder, clearLabel, onChange, onClear }) => {
  return (
    <SearchContainer>
      <InputText
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={event => onChange(event.target.value)}
      />
      {Boolean(value) && (
        <ClearButton
          type="button"
          $iconOnly
          $variant="ghost"
          size="m"
          sizeMobile="s"
          onClick={onClear}
          aria-label={clearLabel}
        >
          <CloseCircleIcon height={20} width={20} fill={theme.colors.defaultWeak} />
        </ClearButton>
      )}
    </SearchContainer>
  )
}

export default PeopleSearchBar

const SearchContainer = styled.div`
  width: 100%;
  display: flex;
  gap: ${({ theme }) => theme.sizing.xs};
  align-items: center;
  position: relative;
`

const ClearButton = styled(Button)`
  flex-shrink: 0;
  position: absolute;
  right: ${({ theme }) => theme.sizing.xs};
`
